import { useMatches } from 'react-router-dom';
import { screenNavigation } from '@/routes/navigation';
import type { ScreenKey } from '@/routes/screens';
import BottomTabBar from './BottomTabBar';

/** Keep one tab bar across ordinary route/layout changes, including route loading. */
export default function AppNavigation() {
  const matches = useMatches();
  const screen = (matches.at(-1)?.handle as { screen?: ScreenKey } | undefined)
    ?.screen;
  const navigation = screenNavigation(screen);
  return navigation.visible ? (
    <BottomTabBar activeTab={navigation.tab} />
  ) : null;
}
